import { useLocalStorageState } from 'ahooks'

import { sa } from '../helpers/sa'

import type { UpgradeSchemaInput } from '@loc/server/interface/track/trackEventParams.common'
import type { ITrackCoreProps } from '.'
import type { IEcommerce, TrackCustomEventProps } from '..'
import type { ICoreItem } from './type'

export const useTrackUpgrade = ({
  eventTracking,
}: ITrackCoreProps): ICoreItem<UpgradeSchemaInput> => {
  const [upgradeIdsLocalStorage, setUpgradeIds] = useLocalStorageState<
    string[]
  >('upgrade-ids', {
    defaultValue: [],
  })

  const trackEvent = async (
    props: UpgradeSchemaInput & TrackCustomEventProps,
  ) => {
    const { name, meta, commonParamsLatest } = props

    const params = [{ name, meta, ...commonParamsLatest.commonParams }]

    const ecommerce = meta as IEcommerce

    const { gaCommonParams } = commonParamsLatest

    const upgradeIds = upgradeIdsLocalStorage || []

    const onTrack = async () => {
      sa.track(name, {
        ecommerce,
        ...gaCommonParams,
      })
      await eventTracking(params)
    }

    if (
      ecommerce?.transaction_id &&
      !upgradeIds.includes(ecommerce.transaction_id)
    ) {
      setUpgradeIds([...upgradeIds, ecommerce.transaction_id])
      await onTrack()
    } else if (process.env.NEXT_PUBLIC_APP_ENV !== 'production') {
      await onTrack()
    }
  }

  return {
    trackEvent,
  }
}
